import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'src/app/global';

@Injectable({
  providedIn: 'root'
})
export class RepuestosService {

  constructor(private http: HttpClient) { }

  public obtenerListaRepuestos(paginator){
    return this.http.get(GlobalVariable.API_SERVER_URL+"repuestos/empresa/"+paginator.filter.id_empresa+"/pagina/"+paginator.currentPage+"/items-pagina/"+paginator.itemsPerPage+"/busqueda/"+paginator.search+"/columna/"+paginator.column+"/direccion/"+paginator.direction+"/grupo/"+paginator.filter.grupo.id+"/subgrupo/"+paginator.filter.subgrupo.id,GlobalVariable.httpOptions);
  }

  public guardarRepuestos(datos){
    return this.http.post(GlobalVariable.API_SERVER_URL+"repuestos/empresa",datos,GlobalVariable.httpOptions);
  }
}
